module.exports = __webpack_public_path__ + "static/media/googletranslate.1f5016e1.svg";